import { useEffect, useState } from 'react';

interface TramesesFilter {
  tipusTramit: string[];
  filial: string[];
}

interface useTramesesFilterResult {
  data: TramesesFilter;
  loading: boolean;
  error: string | null;
}

/**
 * Hook para cargar opciones de filtros desde la API.
 */
export function useTramesesFilter(apiService: {
  GetTramesesTypes: () => Promise<string[]>;
  GetTramesesFilial: (entity : string) => Promise<string[]>;
}, entity : string): useTramesesFilterResult {
  const [data, setData] = useState<TramesesFilter>({
    tipusTramit: [],
    filial: []
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadFilters() {
      setLoading(true);
      setError(null);
      try {
        const [tipusTramit, filial] = await Promise.all([
          apiService.GetTramesesTypes(),
          apiService.GetTramesesFilial(entity)
        ]);
        
        setData({ tipusTramit, filial });
      } catch (err: any) {
        console.error('Error carregant opcions de filtres:', err);
        setError(err.message || 'Error desconegut al carregar filtres');
      } finally {
        setLoading(false);
      }
    }

    loadFilters();
  }, [apiService]);

  return { data, loading, error };
}
